import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "p-grid p-m-0 p-fluid p-jc-center" }
const _hoisted_2 = {
  class: "p-fluid p-formgrid p-grid",
  "data-test": "constraints-form"
}
const _hoisted_3 = { class: "p-field p-col-6" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = {
  for: "label",
  class: "kn-material-input-label"
}
const _hoisted_6 = { class: "p-field p-col-6" }
const _hoisted_7 = { class: "p-float-label" }
const _hoisted_8 = {
  for: "name",
  class: "kn-material-input-label"
}
const _hoisted_9 = { class: "p-field p-col-12" }
const _hoisted_10 = { class: "p-float-label" }
const _hoisted_11 = {
  for: "description",
  class: "kn-material-input-label"
}
const _hoisted_12 = { class: "p-field p-col-4" }
const _hoisted_13 = { class: "p-float-label" }
const _hoisted_14 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_15 = { class: "p-float-label" }
const _hoisted_16 = {
  for: "type",
  class: "kn-material-input-label"
}
const _hoisted_17 = { class: "p-float-label" }
const _hoisted_18 = {
  for: "typeTwo",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_KnValidationMessages = _resolveComponent("KnValidationMessages")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_InputNumber = _resolveComponent("InputNumber")
  const _component_Card = _resolveComponent("Card")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--secondary p-p-0 p-m-0" }, {
      end: _withCtx(() => [
        _createVNode(_component_Button, {
          icon: "pi pi-save",
          class: "kn-button p-button-text p-button-rounded",
          disabled: _ctx.buttonDisabled,
          onClick: _ctx.handleSubmit
        }, null, 8, ["disabled", "onClick"]),
        _createVNode(_component_Button, {
          class: "kn-button p-button-text p-button-rounded",
          icon: "pi pi-times",
          onClick: _ctx.closeForm
        }, null, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Card, {
        style: _ctx.constraintsManagementDetailDescriptor.styles.basicCard,
        class: "p-m-2"
      }, {
        content: _withCtx(() => [
          _createVNode("form", _hoisted_2, [
            _createVNode("div", _hoisted_3, [
              _createVNode("span", _hoisted_4, [
                _createVNode(_component_InputText, {
                  id: "label",
                  class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.constraint.label.$invalid && _ctx.v$.constraint.label.$dirty
                                }],
                  type: "text",
                  modelValue: _ctx.v$.constraint.label.$model,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.v$.constraint.label.$model = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "20",
                  onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.v$.constraint.label.$touch())),
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('touched'))),
                  disabled: _ctx.inputDisabled
                }, null, 8, ["modelValue", "class", "disabled"]),
                _createVNode("label", _hoisted_5, _toDisplayString(_ctx.$t('common.label')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                class: "p-mt-1",
                vComp: _ctx.v$.constraint.label,
                additionalTranslateParams: { fieldName: _ctx.$t('common.label') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_6, [
              _createVNode("span", _hoisted_7, [
                _createVNode(_component_InputText, {
                  id: "name",
                  class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.constraint.name.$invalid && _ctx.v$.constraint.name.$dirty
                                }],
                  type: "text",
                  modelValue: _ctx.v$.constraint.name.$model,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.v$.constraint.name.$model = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "40",
                  onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.v$.constraint.name.$touch())),
                  onInput: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('touched'))),
                  disabled: _ctx.inputDisabled
                }, null, 8, ["modelValue", "class", "disabled"]),
                _createVNode("label", _hoisted_8, _toDisplayString(_ctx.$t('common.name')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                class: "p-mt-1",
                vComp: _ctx.v$.constraint.name,
                additionalTranslateParams: { fieldName: _ctx.$t('common.name') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_9, [
              _createVNode("span", _hoisted_10, [
                _createVNode(_component_InputText, {
                  id: "description",
                  class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.constraint.description.$invalid && _ctx.v$.constraint.description.$dirty
                                }],
                  type: "text",
                  modelValue: _ctx.v$.constraint.description.$model,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.v$.constraint.description.$model = $event)),
                  modelModifiers: { trim: true },
                  disabled: _ctx.inputDisabled,
                  onInput: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('touched'))),
                  maxlength: "160"
                }, null, 8, ["modelValue", "class", "disabled"]),
                _createVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('common.description')), 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                class: "p-mt-1",
                vComp: _ctx.v$.constraint.description,
                additionalTranslateParams: { fieldName: _ctx.$t('common.description') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            _createVNode("div", _hoisted_12, [
              _createVNode("span", _hoisted_13, [
                (!_ctx.constraint.predifined)
                  ? (_openBlock(), _createBlock(_component_Dropdown, {
                      key: 0,
                      id: "type",
                      class: ["kn-material-input", {
                                    'p-invalid': _ctx.v$.constraint.valueTypeCd.$invalid && _ctx.v$.constraint.valueTypeCd.$dirty
                                }],
                      modelValue: _ctx.v$.constraint.valueTypeCd.$model,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.v$.constraint.valueTypeCd.$model = $event)),
                      dataKey: "id",
                      optionLabel: "VALUE_NM",
                      optionValue: "VALUE_CD",
                      options: _ctx.domains,
                      onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.v$.constraint.valueTypeCd.$touch())),
                      onChange: _ctx.clearInput
                    }, null, 8, ["modelValue", "options", "class", "onChange"]))
                  : (_openBlock(), _createBlock(_component_InputText, {
                      key: 1,
                      id: "type",
                      class: "kn-material-input",
                      type: "text",
                      modelValue: _ctx.constraint.valueTypeCd,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.constraint.valueTypeCd = $event)),
                      modelModifiers: { trim: true },
                      disabled: ""
                    }, null, 8, ["modelValue"])),
                _createVNode("label", _hoisted_14, _toDisplayString(_ctx.$t('managers.constraintManagement.type')) + " * ", 1)
              ]),
              _createVNode(_component_KnValidationMessages, {
                class: "p-mt-1",
                vComp: _ctx.v$.constraint.valueTypeCd,
                additionalTranslateParams: { fieldName: _ctx.$t('managers.constraintManagement.type') }
              }, null, 8, ["vComp", "additionalTranslateParams"])
            ]),
            (!_ctx.constraint.predifined && _ctx.constraint.valueTypeCd)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: _ctx.constraintsManagementDetailDescriptor.firstValue[_ctx.constraint.valueTypeCd].class
                }, [
                  _createVNode("span", _hoisted_15, [
                    (!_ctx.numberType)
                      ? (_openBlock(), _createBlock(_component_InputText, {
                          key: 0,
                          id: "type",
                          class: "kn-material-input",
                          type: "text",
                          modelValue: _ctx.constraint.firstValue,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.constraint.firstValue = $event)),
                          modelModifiers: { trim: true },
                          onInput: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue"]))
                      : (_openBlock(), _createBlock(_component_InputNumber, {
                          key: 1,
                          id: "type",
                          inputClass: "kn-material-input",
                          modelValue: _ctx.constraint.firstValue,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.constraint.firstValue = $event)),
                          onInput: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$emit('touched')))
                        }, null, 8, ["modelValue"])),
                    _createVNode("label", _hoisted_16, _toDisplayString(_ctx.$t(_ctx.constraintsManagementDetailDescriptor.firstValue[_ctx.constraint.valueTypeCd].label)), 1)
                  ])
                ], 2))
              : _createCommentVNode("", true),
            (!_ctx.constraint.predifined && _ctx.constraint.valueTypeCd && _ctx.constraint.valueTypeCd == 'RANGE')
              ? (_openBlock(), _createBlock("div", {
                  key: 1,
                  class: _ctx.constraintsManagementDetailDescriptor.firstValue[_ctx.constraint.valueTypeCd].class
                }, [
                  _createVNode("span", _hoisted_17, [
                    _createVNode(_component_InputNumber, {
                      id: "typeTwo",
                      inputClass: "kn-material-input",
                      modelValue: _ctx.v$.constraint.secondValue.$model,
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.v$.constraint.secondValue.$model = $event)),
                      class: {
                                    'p-invalid': _ctx.v$.constraint.secondValue.$invalid && _ctx.v$.constraint.secondValue.$dirty
                                },
                      onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.v$.constraint.secondValue.$touch())),
                      onInput: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$emit('touched')))
                    }, null, 8, ["modelValue", "class"]),
                    _createVNode("label", _hoisted_18, _toDisplayString(_ctx.$t(_ctx.constraintsManagementDetailDescriptor.firstValue[_ctx.constraint.valueTypeCd].labelTwo)), 1)
                  ]),
                  _createVNode(_component_KnValidationMessages, {
                    class: "p-mt-1",
                    vComp: _ctx.v$.constraint.secondValue,
                    additionalTranslateParams: { fieldName: _ctx.$t(_ctx.constraintsManagementDetailDescriptor.firstValue[_ctx.constraint.valueTypeCd].labelTwo) },
                    specificTranslateKeys: { range_check: 'managers.constraintManagement.rangeCheck' }
                  }, null, 8, ["vComp", "additionalTranslateParams", "specificTranslateKeys"])
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["style"])
    ])
  ], 64))
}